import { CompanyListData } from "../api-client/api-client";

export class CompanyListFlags {

	// A = Active
	static isActive(c: CompanyListData): boolean {
		if (c.flags == null)
			return false;
		else
			return c.flags.indexOf('A') >= 0;
	}

	// C = Customer
	static isCustomer(c: CompanyListData): boolean {
		if (c.flags == null)
			return false;
		else
			return c.flags.indexOf('C') >= 0;
	}

	// O = Owner
	static isOwner(c: CompanyListData): boolean {
		if (c.flags == null)
			return false;
		else
			return c.flags.indexOf('O') >= 0;
	}

	// R = Regional Authority
	static isRegionalAuthority(c: CompanyListData): boolean {
		if (c.flags == null)
			return false;
		else
			return c.flags.indexOf('R') >= 0;
	}

	// S = Supplier
	static isSupplier(c: CompanyListData): boolean {
		if (c.flags == null)
			return false;
		else
			return c.flags.indexOf('S') >= 0;
	}

}